import React, { createContext, useCallback } from "react";
import { UserType, PropsUserType } from "./props";
import { useLocalStorage } from "react-use";

let arr: Array<string> = [];

export const DEFAULT_VALUE = {
  user: {
    token: "",
    id: 0,
    name: "",
    email: "",
    company: "",
    job: "",
    phone: "",
    picture: "",
    username: "",
    profile_status: "",
    is_active: false,
    is_staff: false,
    is_superuser: false,
    is_whatsapp: false,
    is_signature: false,
    is_token_config: false,
    remember: false,
    permissions: {
      menus: arr,
      subMenus: arr,
    }
  },
  update: () => { },
};

const UsuarioContext = createContext<PropsUserType>(DEFAULT_VALUE);

const UsuarioContextProvider: React.FC = ({ children }) => {
  const [data, setData] = useLocalStorage<UserType>("user-store", DEFAULT_VALUE.user);

  const update = useCallback(
    (settings: UserType) => {
      setData(settings);
    },
    [setData]
  );

  return (
    //@ts-ignore
    <UsuarioContext.Provider value={{ user: data, update }}>{children}</UsuarioContext.Provider>
  );
};

export { UsuarioContextProvider };
export default UsuarioContext;
